import {useContext, useEffect, useRef} from "react";
import {useFormContext} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {InputGroupField} from "@/components/form/fields/InputGroupField/InputGroupField.tsx";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";

import {nameToSlug} from "./StatusPageSlugField.utils.ts";

export const StatusPageSlugField = () => {
  const {watch, setValue, getValues} = useFormContext();
  const nameValue = watch("name");
  const slugValue = watch("slug");
  const {brand} = useCurrentUserContext();
  // Absent in the create flow, where there is no page yet and the legacy prefix applies.
  const {statusPage} = useContext(StatusPageContext);
  const servedBySpa = statusPage.is_served_by_spa && brand.consumptionURL;
  const urlPrefix = servedBySpa ? `${brand.consumptionURL}/` : `${brand.siteURL}/statuspage/`;

  const slugManuallyEdited = useRef(false);
  const lastAutoSlug = useRef("");
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      const initialSlug = getValues("slug");
      if (initialSlug && initialSlug !== nameToSlug(getValues("name") ?? "")) {
        slugManuallyEdited.current = true;
      }
    }
  }, [getValues]);

  useEffect(() => {
    if (!slugManuallyEdited.current) {
      const autoSlug = nameToSlug(nameValue ?? "");
      lastAutoSlug.current = autoSlug;
      if (slugValue === "" && autoSlug === "") {
        return;
      }
      setValue("slug", autoSlug, {shouldValidate: true});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameValue, setValue]);

  const handleSlugChange = () => {
    const currentSlug = getValues("slug");
    if (currentSlug !== lastAutoSlug.current) {
      slugManuallyEdited.current = true;
    }
  };

  return (
    <InputGroupField
      name={"slug"}
      label={"Public URL"}
      tooltip={"This is the URL path/foldername that you can ThemePreview (letters, numbers and hyphens only)."}
      required
      startAddon={urlPrefix}
      helpText={"Auto-generated from your page name. You can edit it manually."}
      options={{onChange: handleSlugChange}}
    />
  );
};
